'use client';

import { useEffect } from 'react';
import { useShallow } from 'zustand/shallow';
import { useUiState } from '@/store';
function InitState(_setIsDark: (isDark: boolean) => void) {
  _setIsDark(true);
}
export const ThemeController = () => {
  const [_isDark, _setIsDark] = useUiState(useShallow(st => [st.isDark, st.setIsDark]));
  useEffect(() => {
    InitState(_setIsDark);
  }, [_setIsDark]);
  useEffect(() => {
    document.documentElement.classList.toggle('dark', _isDark);
  }, [_isDark]);
  return null;
};